import { getLogger as getGatewayLogger } from '@interopio/gateway/logging/core';

export type Logger = ReturnType<typeof getGatewayLogger>;

export default function getLogger(name: string): Logger {
    return getGatewayLogger(`gateway.bridge.${name}`);
}
